import React from 'react';
import AddPatient from '../component-add-patient';
import Suspense from '../../Common/components/Suspense-component';

import { getPharmacyOfUser, getUserStatus, getCurrentUser } from '../../Users/epics-users';

import { getPharmacyList } from '../../Pharmacies/epics-pharmacies';
import localStorage from '../../Common/LocalStorage';
import { getPharmaciesForSingleCompany } from '../../Companies/epics-companies';
import { UserRole } from '../../Common/UserRole';

export class AddPatientContainer extends React.Component {
    generatePharmacyList = id => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return getPharmacyList();
            case UserRole.STORE_OWNER:
                return id ? getPharmaciesForSingleCompany(id) : [];
            case UserRole.PHARMACY_MANAGER:
                return getPharmacyOfUser();
            case UserRole.PHARMACIST:
                return getPharmacyOfUser();
            default:
                return [];
        }
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    status: getUserStatus,
                    companyOwner: getCurrentUser,
                    pharmacyList: id => this.generatePharmacyList(id)
                }}
            >
                <AddPatient />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Patients/containers/container-add-patient.js